// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"644":"1e6b2560","667":"2e5f6a31"}[chunkId] + ".chunk.js";
};